module.exports = __webpack_public_path__ + "static/img/award4_a.37e2be5.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award4_a.png
// module id = kMXQ
// module chunks = 7